import { wrapClientApiCall } from '../../../utils'

export const fetchConsumerOrderDetail = order_id =>
    wrapClientApiCall({
        actionRoot: 'FETCH_CONSUMER_ORDER_DETAIL',
        url: `api/orders/fetch-detail?order_id=${order_id}&getPayments=true`,
    })
